var curried, f,
  __slice = [].slice;

f = require('./to-function');

curried = function(length, fn) {
  if (typeof length === 'function') {
    fn = length;
    length = fn.length;
  }
  return function() {
    if (arguments.length < length) {
      return curried(length - arguments.length, f.apply(null, [fn].concat(__slice.call(arguments))));
    } else {
      return fn.apply(this, arguments);
    }
  };
};

module.exports = curried;
